export default __webpack_public_path__ + "f0bc4a4aef04e1d500dcf2fc8143f078.png";